module.exports = __webpack_public_path__ + "static/media/icon_rain.f9d18ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_rain.png
// module id = 525
// module chunks = 0